import React from "react"
import Features from "@views/features"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Features"
      keywords={[
        `engineid`,
        `security`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <Features />
  </div>
)

export default IndexPage
